import apiClient from './meta-client';

// ========== TYPES ==========

export interface PageAccess {
    id: number;
    user_id: number;
    page_id: number;
    can_access?: boolean;
    can_view: boolean;
    can_edit: boolean;
    can_broadcast: boolean;
    granted_by: number;
    created_at: string;
    updated_at: string;
}

export interface PageAccessWithUser extends PageAccess {
    user_name: string | null;
    user_email: string | null;
}

export interface PageAccessWithPage extends PageAccess {
    meta_page_id: string | null;
    page_name: string | null;
    picture_url: string | null;
}

export interface GrantAccessInput {
    page_id: number;
    can_view?: boolean;
    can_edit?: boolean;
    can_broadcast?: boolean;
}

export interface GrantBulkAccessInput {
    page_ids: number[];
    can_view?: boolean;
    can_edit?: boolean;
    can_broadcast?: boolean;
}

// ========== API ==========

export const getUserPageAccesses = async (userId: number): Promise<PageAccessWithPage[]> => {
    const response = await apiClient.get(`/page-access/users/${userId}/pages`);
    return response.data;
};

export const getPageUsers = async (pageId: number): Promise<PageAccessWithUser[]> => {
    const response = await apiClient.get(`/page-access/pages/${pageId}/users`);
    return response.data;
};

export const getMyPageAccesses = async (): Promise<PageAccessWithPage[]> => {
    const response = await apiClient.get('/page-access/my-pages');
    return response.data;
};

export const grantAccess = async (userId: number, data: GrantAccessInput): Promise<any> => {
    const response = await apiClient.post(`/page-access/users/${userId}/grant`, data);
    return response.data;
};

export const grantBulkAccess = async (userId: number, data: GrantBulkAccessInput): Promise<any> => {
    const response = await apiClient.post(`/page-access/users/${userId}/grant-bulk`, data);
    return response.data;
};

export const grantTotalBulkAccess = async (userId: number, pageIds: number[]): Promise<any> => {
    const response = await apiClient.post(`/page-access/users/${userId}/grant-total-bulk`, {
        page_ids: pageIds,
    });
    return response.data;
};

export const revokeAccess = async (userId: number, pageId: number): Promise<any> => {
    const response = await apiClient.delete(`/page-access/users/${userId}/pages/${pageId}`);
    return response.data;
};

export const revokeAllAccess = async (userId: number): Promise<any> => {
    const response = await apiClient.delete(`/page-access/users/${userId}/pages`);
    return response.data;
};
